import { useEffect, useState, useMemo } from 'react';
import { Page, PageTitle, Table, Toast } from '../../../components';
import { Button } from '@mui/material';
import { GroupModal } from './GroupModal';
import { Edit } from '@mui/icons-material';
import { getAdminGroups } from '../../../fetch';
import { IGroup } from '../../../models';

export const ManageGroups = () => {
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [isError, showError] = useState<boolean>(false);
  const [isLoadingGroups, setLoadingGroups] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isGroupModalOpen, showGroupModal] = useState<boolean>(false);
  const [currentGroup, setCurrentGroup] = useState<any>(null);

  const fetchGroups = async () => {
    try {
      setLoadingGroups(true);
      const res = await getAdminGroups();
      setGroups(res);
    } catch (error) {
      setErrorMessage('Error loading groups, please refresh and try again.');
      console.log(error);
    } finally {
      setLoadingGroups(false);
    }
  };

  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = useMemo(() => {
    return [
      {
        Header: 'Name',
        accessor: 'name',
        sort: false
      },
      {
        Header: 'Description',
        accessor: 'description',
        sort: false
      },
      {
        id: 'actions',
        accessor: '',
        Header: '',
        overrideWidth: 200,
        Cell: ({
          cell: {
            row: { original }
          }
        }: {
          cell: { row: { original: any } };
        }) => {
          return (
            <>
              <Button
                id="edit"
                color="primary"
                startIcon={<Edit />}
                onClick={async () => {
                  showGroupModal(true);
                  setCurrentGroup(original);
                }}
              >
                Edit Users
              </Button>
            </>
          );
        }
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups]);

  return (
    <Page title="Manage Document Groups">
      <PageTitle title="Manage Document Groups" />
      <Table columns={columns} data={groups} isLoading={isLoadingGroups} hidePagination />
      <Toast id="groups-error" autoHideDuration={5000} message={errorMessage} open={isError} onClose={() => showError(false)} variant="error" />
      {currentGroup && (
        <GroupModal
          currentGroup={currentGroup}
          open={isGroupModalOpen}
          onClose={() => {
            showGroupModal(false);
            setTimeout(() => {
              setCurrentGroup(null);
            }, 500);
          }}
          fetchGroups={fetchGroups}
        />
      )}
    </Page>
  );
};
